import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { InterceptorService } from './shared/http/interceptor.service';
import { SharedModule } from './shared/shared.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FormatTimePipe, VerificationComponent } from './auth/verification/verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ErrorCatchingInterceptor } from './shared/http/error-catching.interceptor';
import { CdkTableModule } from '@angular/cdk/table';
import { HealthCheckComponent } from './health-check.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        VerificationComponent,
        FormatTimePipe,
        HealthCheckComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        CdkTableModule,
        MatTableModule,
        MatSnackBarModule,
        MatDialogModule,
        SharedModule,
        NgxMatSelectSearchModule,
        NgOtpInputModule,
        MatIconModule,
        NgIdleKeepaliveModule.forRoot()], providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorCatchingInterceptor,
            multi: true
        }, provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class AppModule { }
